<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-05">ORGANIZATION OF THE DEPARTMENT OF BLISS (1998)</p>
<p class="fm-03">Department of Bliss (DOB)</p>
<p class="fm-03">Director (DIROB)</p>
<p class="fm-03">Headquarters Staff</p>
<p class="fm-04">Prosperity Section (PROSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRPRO)</p>
<p class="fm-04">Wisdom Section (WISSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRWIS)</p>
<p class="fm-04">Vigor Section (VIGSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRVIG)</p>
<p class="fm-04">Culture Section (CULSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRCUL)</p>
<p class="fm-04">Satisfaction Section (SATSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRSAT)</p>
<p class="fm-05">ORGANIZATION OF SATISFACTION SECTION, DOB</p>
<p class="fm-03">Satisfaction Section (SATSEC)</p>
<p class="fm-03">Deputy Director (DEPDIRSAT)</p>
<p class="fm-03">Headquarters Staff</p>
<p class="fm-04">Division of Research &amp; Development (DIVRAD)</p>
<p class="fm-03">Assistant Deputy Director (AssDepDirRad)</p>
<p class="fm-04">Division of Security &amp; Intelligence (DIVSEC)</p>
<p class="fm-03">Assistant Deputy Director (AssDepDirSec)</p>
<p class="fm-04">Division of Data &amp; Statistics (DIVDAT)</p>
<p class="fm-03">Assistant Deputy Director (AssDepDirDat)</p>
<p class="fm-04">Division of Law &amp; Enforcement (DIVLAW)</p>
<p class="fm-03">Assistant Deputy Director (AssDepDirLaw)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter02.vue?472fe7af